<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{caption}}<strong v-if="required" class="required">*</strong>
        </template>
        <template slot="input">
            <div style="display: flex; flex-flow: row; align-items: center;">
                <v-date-picker
                        v-model="pickerValue"
                        :attributes="dateAttributes"
                        locale="en"
                        color="red"
                        :popover="{visibility: 'click', placement: 'bottom'}"
                        @input="handleCalendarInput">

                    <template v-slot="{ inputValue, inputEvents }">
                        <icon v-on="inputEvents" :icon="['fal', 'calendar']"/>
                    </template>
                </v-date-picker>
                <input v-bind:value="internalValue" placeholder="<no date>" type="text"
                       :class="{ 'input-component': true, 'active': active}"
                       @input="pipeInput"
                       @keyup.enter="validateAndOutput"
                       @blur="onBlur"
                       @focus="toggleActive"/>
            </div>
        </template>
    </form-input-layout>
</template>

<script>
    import FormInputLayout from "./FormInputLayout";
    import {Vue} from "vue";
    export default {
        name: "FormDateInput",
        components: {FormInputLayout},
        props: {
            value: [Object, String, Date],
            caption: String,
            disabled: Boolean,
            required: Boolean,
            helpItemCode: String
        },
        data: function() {
            return {
                internalValue: "",
                finalValue: "",
                active: false,
                pickerValue: null,
                dateAttributes: [
                    {
                        key: 'today',
                        highlight: {
                            style: {
                                borderColor: '#c84a4b', //accent-color
                                borderWidth: '2px',
                                borderStyle: 'solid',
                            },

                        },
                        dates: new Date(),
                        order: 100

                    },
                ],
            }
        },
        methods: {
            handleCalendarInput(input) {
                const parsedDate = this.$formats.formatDate(
                    (input.getYear()+1900) + "-" + (input.getMonth()+1) + "-" + input.getDate() + "T00:00:00", false);
                if(parsedDate != this.internalValue) {
                    this.internalValue = this.$formats.formatDate(
                        (input.getYear()+1900) + "-" + (input.getMonth()+1) + "-" + input.getDate() + "T00:00:00", false);
                    this.validateAndOutput();
                }

            },
            onBlur() {
              this.toggleActive();
              this.validateAndOutput();
            },
            toggleActive() {
                this.active = !this.active;
            },
            pipeInput($event) {
                this.internalValue = $event.target.value;
            },
            adjustInput() {
                if(this.internalValue == "") return;
                if(this.$formats.parseDate(this.internalValue) === 'Invalid date') {
                    let finalDate = new Date();
                    if(typeof this.relativeTo != 'undefined' && this.relativeTo != "") {
                        finalDate = new Date(this.relativeTo);
                    }
                    let offset = (token) => {
                        if(token.indexOf("d") > -1) {
                            finalDate = finalDate.addDays(+token.substring(0, token.length - 1));
                        }
                        if(token.indexOf("w") > -1) {
                            finalDate = finalDate.addDays(+token.substring(0, token.length - 1) * 7);
                        }
                        if(token.indexOf("m") > -1) {
                            finalDate = finalDate.addDays(+token.substring(0, token.length - 1) * 30);
                        }
                    };
                    let tokens = this.internalValue.split(">");
                    tokens.forEach(tkn => offset(tkn));

                    this.internalValue = this.$formats.formatDate(
                        (finalDate.getYear()+1900) + "-" + (finalDate.getMonth()+1) + "-" + finalDate.getDate() + "T00:00:00", false);
                }
            },
            validateAndOutput() {
                this.validate();
                this.adjustInput();
                this.$emit("input", this.internalValue == "" ? "" : this.$formats.parseDate(this.internalValue));
            },
            validate() {

            }
        },
        watch: {
            value: {
                handler(newValue) {
                    if(newValue == "" || newValue == null) {
                        this.internalValue = "";
                    }
                    else {
                        this.internalValue = this.$formats.formatDate(newValue);
                        this.$emit("input", this.$formats.parseDate(this.internalValue));
                        this.pickerValue = new Date(this.$formats.parseDate(this.internalValue));
                    }
                },
                immediate: true
            }
        }
    }

</script>

<style lang="scss" scoped>
    @import "../../styles/global";
    .input-component {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid var(--input-border-color);
        background-color: var(--input-background-color);
        border-radius: 5px;
        color: var(--input-font-color);
        padding: 2px 10px 2px 10px;
        outline: none;
        width: 100%;
        font-family: Source Sans Pro;
        margin-left: 10px;
    }

    .active {
        color: var(--input-active-font-color);
        background-color: var(--input-active-background-color);
        border: 1px solid var(--input-active-border-color);
    }

    .required {
        color: var(--accent-color);
    }

</style>